// ---------------------------------------------------------------------
// 🔒 AUTOGENERATED @synergy-design-system/react wrappers for @synergy-design-system/components
// Please do not edit this file directly!
// It will get recreated when running pnpm build.
// ---------------------------------------------------------------------
import * as React from 'react';
import { createComponent } from '@lit/react';
import Component from '@synergy-design-system/components/components/menu/menu.component.js';

import { type EventName } from '@lit/react';
import type { SynSelectEvent } from '@synergy-design-system/components';

const tagName = 'syn-menu';
Component.define('syn-menu');

/**
 * @summary Menus provide a list of options for the user to choose from.
 * @documentation https://synergy-design-system.github.io/?path=/docs/components-syn-menu--docs
 * @status stable
 * @since 2.0
 *
 * @slot - The menu's content, including menu items, menu labels, and dividers.
 *
 * @event {{ item: SynMenuItem }} syn-select - Emitted when a menu item is selected.
 */
export const SynMenu = createComponent({
  displayName: 'SynMenu',
  elementClass: Component,
  events: {
    onSynSelect: 'syn-select' as EventName<SynSelectEvent>,
  },
  react: React,
  tagName,
});

export type { SynSelectEvent } from '@synergy-design-system/components';
